import request from '../utils/request'
import { ParamsProps, ReturnType } from './types'
const getConversations = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'conversations',
      method: 'get',
      params: args?.params || {},
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: args?.action,
          key: 'conversations',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const getMessages = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'messages',
      method: 'get',
      params: args?.params || {},
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: args?.action,
          key: 'messages',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err.message)
  }
}

export default {
  getConversations,
  getMessages,
}
